import axios from 'axios'
import * as types from '../mutation-types'

export const namespaced = true

// state
export const state = {
  dineTimes: null
}

// getters
export const getters = {
  dineTimes: state => state.dineTimes
}

// mutations
export const mutations = {
  [types.SET_DINE_MODE_DINE_IN_TIMES] (state, timeslots) {
    state.dineTimes = timeslots
  }
}

// actions
export const actions = {
  async fetchDineInTimes ({ commit, rootGetters }) {
    const rid = parseInt(rootGetters['config/rid']) === 0 ? parseInt(rootGetters['config/rid2']) : parseInt(rootGetters['config/rid'])
    try {
      const params = {
        restaurant_id: rid
      }
      const { data } = await axios.post('/api/restaurant/dine_in_times', params)
      commit(types.SET_DINE_MODE_DINE_IN_TIMES, data)
    } catch (e) {

    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/dine_mode.js